import React from 'react';

const LeaderboardWidgetFavoriteCellTitle = ({ state }) => {
    return (
        <div className={`leaderboard-widget-favorite__cell is-title is-${state.id}`}>
            {state.textTitle}
        </div>
    );
};

export default LeaderboardWidgetFavoriteCellTitle;
